import { useEffect, useMemo, useState } from 'react';
import { useToast } from 'context/tostifyContext';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

function useMetadata() {
  const [data, setData] = useState([]);
  const [selectedKey, setSelectedKey] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [form, setForm] = useState({ keyName: '', keyValue: '' });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { showToast } = useToast();

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const res = await customAxios.get('/GenTasks/GetMetaData', { headers: authHeader() });
        setData(res.data);
      } catch (err) {
        console.log(err);
        showToast('Failed to fetch Metadata', 'error');
      }
    };

    fetchMetadata();
  }, []);

  const keyNames = useMemo(() => {
    return [...new Set(data.map(item => item.keyName))];
  }, [data]);

  const filteredData = useMemo(() => {
    return selectedKey ? data.filter(item => item.keyName === selectedKey) : [];
  }, [data, selectedKey]);

  const openEditModal = row => {
    setIsEditMode(true);
    setCurrentRow(row);
    setForm({ keyName: row.keyName, keyValue: row.keyValue, keyId: row.id });
    setOpenModal(true);
  };

  const handleOpenDeleteModal = row => {
    setCurrentRow(row);
    setForm({ keyName: row.keyName, keyValue: row.keyValue, keyId: row.id });
    setOpenDeleteModal(true);
  };

  const openAddModal = () => {
    setIsEditMode(false);
    setCurrentRow(null);
    setForm({ keyName: selectedKey, keyValue: '' });
    setOpenModal(true);
  };

  const saveMetadata = async () => {
    if (isEditMode) {
      const updated = data.map(item => (item.id === currentRow.id ? { ...item, keyValue: form.keyValue } : item));
      setData(updated);
      console.log(form, 'data');

      await customAxios.post('/GenTasks/DeleteMetaData', { id: form.keyId }, { headers: authHeader() });

      const newItem = {
        keyName: form.keyName,
        keyValue: form.keyValue,
      };
      await customAxios.post('/GenTasks/AddMetaData', newItem, { headers: authHeader() });

      showToast('Edited Metadata');
    } else {
      const newItemPayload = {
        keyName: form.keyName,
        keyValue: form.keyValue,
      };

      await customAxios.post('/GenTasks/AddMetaData', newItemPayload, { headers: authHeader() });
      setOpenModal(false);

      const res = await customAxios.get('/GenTasks/GetMetaData', { headers: authHeader() });

      setData(res.data);

      showToast('Added new Metadata');
    }
    setOpenModal(false);
  };

  const handleDeleteMetadata = () => {
    try {
      const res = customAxios.post('GenTasks/DeleteMetaData', { id: form.keyId }, { headers: authHeader() });
      setOpenDeleteModal(false);
      showToast('Metadata Deleted succesfully .');
    } catch (err) {
      showToast('Error in deleting metadata', 'error');
      setOpenDeleteModal(false);
    }

    const updated = data.filter(item => item.id != form.keyId);
    setData(updated);
  };

  return {
    data,
    keyNames,
    selectedKey,
    setSelectedKey,
    filteredData,
    openModal,
    setOpenModal,
    isEditMode,
    form,
    setForm,
    openEditModal,
    openAddModal,
    saveMetadata,
    openDeleteModal,
    setOpenDeleteModal,
    handleOpenDeleteModal,
    handleDeleteMetadata,
  };
}

export default useMetadata;
